import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { getPlayKitProductDescription } from '@/utils/productHelpers';

export interface AboutYourPlayKitProps {
  title: string;
  description: string | null | undefined;
}

function AboutYourPlayKit({ title, description }: AboutYourPlayKitProps) {
  const htmlString = description || '';
  const formattedDescription = getPlayKitProductDescription(htmlString);

  return (
    <div className="flex flex-col mb-6 md:mb-8">
      <Heading
        classes="mb-2"
        tag={HeadingTag.H3}
        size={HeadingSize.H3}
        text={title}
      />
      {formattedDescription && (
        <p
          className="md:text-base text-sm"
          dangerouslySetInnerHTML={{ __html: formattedDescription }}
        />
      )}
    </div>
  );
}

export default AboutYourPlayKit;
